/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
import * as Yup from "yup";
import { formatNumber, getModuleNamingBySlug } from "./Misc";

const PASSWORD_VALIDATOR =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/;

const COMMON_VALIDATOR_FOR_STRING = /^[^!@#)(^%$<>][a-zA-Z\s\d.,&-']*$/;

// const NUMBER_VALIDATOR = /^\d*\.?\d*$/;

/**
 * Email Validation
 */
const email = Yup.string()
  .required("Email address is required.")
  .email("Please enter a valid email address. For eg. example@example.com")
  .nullable();

const notRequiredEmail = Yup.string()
  .email("Please enter a valid email address. For eg. example@example.com")
  .nullable();

/**
 * First Name Validation
 */
const FIRSTNAME_VALIDATOR = /^[a-zA-Z\s]*$/;
const FIRSTNAME_MESSAGE = "First name can contain letters & spaces.";
const requiredFirstName = Yup.string()
  .required("First name is required.")
  .matches(FIRSTNAME_VALIDATOR, FIRSTNAME_MESSAGE)
  .nullable();
const firstName = Yup.string()
  .matches(FIRSTNAME_VALIDATOR, FIRSTNAME_MESSAGE)
  .nullable();

/**
 * Last Name Validation
 */
const LASTNAME_VALIDATOR = /^[^!@#)(^%$<>][a-zA-Z\s\d.,&'-]*$/;
const LASTNAME_MESSAGE =
  "Last name can contain letters, numbers, ampersand(&), dot(.), comma(,), apostrophe('), hyphen(-) & spaces.";
const requiredLastName = Yup.string()
  .required("Last name is required.")
  .matches(LASTNAME_VALIDATOR, LASTNAME_MESSAGE)
  .nullable();

/**
 * Business Name Validation
 */
const BUSINESSNAME_VALIDATOR = /^[^!@#%^$<>][a-zA-Z\s\d.,&'/()-]*$/;
const BUSINESSNAME_MESSAGE =
  "Business name can contain letters, numbers, ampersand(&), dot(.), comma(,), apostrophe('), hyphen(-), parentheses(), slashes(/) & spaces.";
const requiredBusinessName = Yup.string()
  .required("Business Name is required.")
  .max(200, "Maximum 200 Character")
  .matches(BUSINESSNAME_VALIDATOR, BUSINESSNAME_MESSAGE)
  .nullable();
const businessName = Yup.string()
  .max(200, "Maximum 200 Character")
  .matches(BUSINESSNAME_VALIDATOR, BUSINESSNAME_MESSAGE)
  .nullable();

/**
 * Address Validation
 */
const ADDRESS_VALIDATOR = /^[^!@#%^$<>][a-zA-Z\s\d.,&'/()-]*$/;
const ADDRESS_MESSAGE =
  "Address can contain letters, numbers, ampersand(&), dot(.), comma(,), hyphen(-), apostrophe('), parentheses(), slashes(/) & spaces.";
const requiredAddress = Yup.string()
  .required("Address is required.")
  .max(200, "Maximum 200 Character")
  .matches(ADDRESS_VALIDATOR, ADDRESS_MESSAGE)
  .nullable();
const address = Yup.string()
  .max(200, "Maximum 200 Character")
  .matches(ADDRESS_VALIDATOR, ADDRESS_MESSAGE)
  .nullable();

/**
 * Bank Account Validation
 */
const bankAccountName = Yup.string()
  .max(200, "Must be less than 200 character")
  .matches(
    /^[^!@#)(^%$<>][a-zA-Z\s\d.,&-]*$/,
    `Account name can contain letters, numbers, ampersand(&), dot(.), comma(,), hyphen(-) & spaces.`,
  );
const requiredBankAccountName = Yup.string()
  .required("Account name is required.")
  .max(200, "Must be less than 200 character")
  .matches(
    /^[^!@#)(^%$<>][a-zA-Z\s\d.,&-']*$/,
    `Account name can contain letters, numbers, ampersand(&), dot(.), comma(,), apostrophe('), hyphen(-) & spaces.`,
  );

const requiredBankAccountNamewithTrust = Yup.string()
  .required("Account name is required.")
  .max(200, "Must be less than 200 character")
  .matches(
    /^[^!@#)(^%$<>][a-zA-Z\s\d.,&-']*$/,
    `Account name can contain letters, numbers, ampersand(&), dot(.), comma(,), apostrophe('), hyphen(-) & spaces.`,
  )
  .lowercase()
  .matches("trust", "Must include Trust key-word");

/**
 * Account Number Validation
 */
const ACCOUNTNUMBER_VALIDATOR = /^(\d)(?!\1+$)\d{0,8}$/;
const ACCOUNTNUMBER_MESSAGE =
  "Please enter valid Account Number. All digits of same number are not allowed.";
const requiredAccountNumber = Yup.string()
  .required("Account Number is required.")
  .max(9, "Account Number must be less than 10 digit number.")
  .matches(ACCOUNTNUMBER_VALIDATOR, ACCOUNTNUMBER_MESSAGE)
  .nullable();
const accountNumber = Yup.string()
  .max(9, "Account Number must be less than 10 digit number.")
  .matches(ACCOUNTNUMBER_VALIDATOR, ACCOUNTNUMBER_MESSAGE)
  .nullable();

/**
 * BSB Validation
 */
const requiredBSB = Yup.string().required("BSB is required.").nullable();

/**
 * Bank Name Validation
 */
const requiredBankName = Yup.string()
  .required("Bank name is required.")
  .nullable();

export const MyProfileSchema = Yup.object().shape({
  first_name: requiredFirstName,
  last_name: requiredLastName,
  email: email,
});

export const AddVendorSchema = Yup.object().shape({
  first_name: firstName,
  last_name: requiredLastName,
  email: email,
  // account_name: requiredBankAccountName,
  // account_number: requiredAccountNumber,
  // bsb: requiredBSB,
  // bank_id: requiredBankName,
});

/**
 * Project Name Validation
 */
const ASSETNAME_VALIDATOR = /^[^!@#^%$<>][a-zA-Z\s\d.)(,\-&']*$/;
const ASSETNAME_MESSAGE =
  "Asset name can contain letters, numbers, ampersand(&), dot(.), comma(,), apostrophe(') hyphen(-) & spaces.";
const requiredAssetName = (contextData) =>
  Yup.string()
    .required(
      `${getModuleNamingBySlug(
        contextData?.organizationData,
        "assets",
        "Asset",
      )} Name is required.`,
    )
    .max(200, "Maximum 200 Character")
    .matches(ASSETNAME_VALIDATOR, ASSETNAME_MESSAGE)
    .nullable();
const PAYERTNAME_MESSAGE =
  "Payer name can contain letters, numbers, ampersand(&), dot(.), comma(,), hyphen(-), Parentheses(()) & spaces.";
const requiredPayerName = Yup.string()
  .required("Payer Name is required.")
  .max(200, "Maximum 200 Character")
  .matches(ASSETNAME_VALIDATOR, PAYERTNAME_MESSAGE)
  .nullable();
// const projectName = Yup.string()
//   .max(200, "Maximum 200 Character")
//   .matches(ASSETSNAME_VALIDATOR, ASSETSNAME_MESSAGE)
//   .nullable();

export const AddAssetSchema = (contextData) => {
  return Yup.object().shape({
    vendor_id: Yup.string()
      .required(
        `${getModuleNamingBySlug(
          contextData?.organizationData,
          "vendors",
          "Vendor",
        )} is required.`,
      )
      .nullable(),
    asset_name: requiredAssetName(contextData),
    is_sub_asset: Yup.boolean(), // ✅ this is required for .when() to work

    sub_asset_tax_type: Yup.string()
      .nullable()
      .when("is_sub_asset", {
        is: true,
        then: (schema) => schema.required("Tax type is required."),
        otherwise: (schema) => schema.strip(), // removes it from validation
      }),

    sub_asset_tax_percentage: Yup.string()
      .transform((value) => (value === "" ? null : value)) // handle empty string
      .nullable()
      .when(["is_sub_asset"], {
        is: (is_sub_asset) => is_sub_asset === true,
        then: (schema) => schema.required("Tax percentage is required."),
        otherwise: (schema) => schema.notRequired().strip(),
      }),
  });
};

export const ChangePasswordSchema = Yup.object().shape({
  old_password: Yup.string()
    .required("Current Password is required.")
    .nullable(),

  new_password: Yup.string()
    .required("New Password is required.")
    .notOneOf(
      [Yup.ref("old_password")],
      "Current and New Password should not be the same.",
    )
    .matches(
      PASSWORD_VALIDATOR,
      "Must contain 8 characters, one uppercase, one lowercase, one number, and one special character.",
    )
    .nullable(),

  password_confirmation: Yup.string()
    .required("Confirm Password is required.")
    .oneOf([Yup.ref("new_password")], "Both passwords need to be the same.")
    .nullable(),
});

export const AddSubAssetSchema = (contextData) => {
  return Yup.object({
    vendor_id: Yup.string()
      .required(
        `${getModuleNamingBySlug(
          contextData?.organizationData,
          "vendors",
          "Vendor",
        )} is required.`,
      )
      .nullable(),
    asset_id: Yup.string()
      .required(
        `${getModuleNamingBySlug(
          contextData?.organizationData,
          "assets",
          "Asset",
        )} is required.`,
      )
      .nullable(),
    name: Yup.string().required("Name is required.").nullable(),
    tax_type: Yup.string().required("Tax type is required.").nullable(),
    // tax_percentage: Yup.string()
    //   .nullable()
    //   .when("tax_type", {
    //     is: "1",
    //     then: (schema) =>
    //       schema.required("Tax percentage is required when tax type is 1."),
    //     otherwise: (schema) => schema.notRequired(),
    //   }),

    tax_percentage: Yup.string()
      .required("Tax percentage is required .")
      .nullable(),
  });
};

export const FirmSignupSchema = Yup.object().shape({
  first_name: requiredFirstName,
  last_name: requiredLastName,
  phone: Yup.string().required("Phone Number is required."),
  email: email,
  password: Yup.string()
    .required("Password is required.")
    .matches(
      PASSWORD_VALIDATOR,
      "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character.",
    )
    .nullable(),
  password_confirmation: Yup.string()
    .nullable()
    .when("password", {
      is: (val) => !!val, // Safer boolean check
      then: (schema) =>
        schema
          .required("Re-type Password is required.")
          .oneOf([Yup.ref("password")], "Both passwords must match."),
      otherwise: (schema) => schema.notRequired(),
    }),
  business_name: requiredBusinessName,
  business_email: email,
  type: Yup.string().required("Type is required.").nullable(),
  street: requiredAddress,
  state_id: Yup.string().required("State name is required.").nullable(),
  suburb_id: Yup.string().required("Suburb name is required.").nullable(),
  postal_code: Yup.string().required("Postal Code is required."),
});

export const AddBankTransactionSchema = Yup.object().shape({
  // account: Yup.object().required("Account is required.").nullable(),
  // transactionDate: Yup.string()
  //   .required("Transaction Date is required.")
  //   .nullable(),
  amount: Yup.string().required("Amount is required.").nullable(),
  base_type: Yup.string().required("Transaction Type is required.").nullable(),
  description: Yup.string()
    .required("Description is required.")
    .max(150, "Maximum 150 Character")
    .nullable(),
});

export const ForgotPasswordSchema = Yup.object().shape({
  email: email,
});

export const ResetPasswordSchema = Yup.object().shape({
  email: email,
  password: Yup.string()
    .required("New Password is required.")
    .matches(
      PASSWORD_VALIDATOR,
      "Must contain 8 characters, one uppercase, one lowercase, one number, and one special character.",
    )
    .nullable(),

  password_confirmation: Yup.string()
    .required("Confirm Password is required.")
    .oneOf([Yup.ref("password")], "Both passwords need to be the same.")
    .nullable(),
});

// Add Payment Schema
const paymentDataSchema = (contextData) => {
  return Yup.object().shape({
    contact_id: Yup.string().required(
      `${getModuleNamingBySlug(
        contextData?.organizationData,
        "contacts",
        "Customer",
      )} is required.`,
    ),
    total_amount: Yup.number().required("Total Amount is required"),
    account_name: Yup.string().required("Account Name is required"),
    bsb: Yup.string().required("BSB is required"),
    account_number: Yup.number().required("Account number is required"),
    description: Yup.string().required("Description is required"),
  });
};

const paymentSchema = (contextData) => {
  return Yup.object().shape({
    contact_id: Yup.string()
      .nullable()
      .when("$payee", {
        is: (payee) => {
          console.log("payee in yup:", payee);
          return payee !== "vendor";
        },
        then: (schema) =>
          schema.required(
            `${getModuleNamingBySlug(
              contextData?.organizationData,
              "contacts",
              "Customer",
            )} is required.`,
          ),
        otherwise: (schema) => schema.notRequired().nullable(),
      }),
    vendor_id: Yup.string().required(
      `${getModuleNamingBySlug(
        contextData?.organizationData,
        "vendors",
        "Vendor",
      )} is required.`,
    ),
    asset_id: Yup.string().required(
      `${getModuleNamingBySlug(
        contextData?.organizationData,
        "assets",
        "Asset",
      )} is required.`,
    ),
    sub_asset_id: Yup.string().required(
      `${getModuleNamingBySlug(
        contextData?.organizationData,
        "sub-assets",
        "Sub Asset",
      )} is required.`,
    ),
    payment_data: Yup.array()
      .of(paymentDataSchema(contextData))
      .min(1, "At least one payment data entry is required"),
  });
};

export const AddPaymentSchema = (contextData) => {
  return Yup.object().shape({
    // file_note: Yup.string().required("File note is required"),
    // invoice_number: Yup.string().required("Invoice Number is required"),
    payee: Yup.string().required("Payee is required").nullable(),
    payments: Yup.array()
      .of(paymentSchema(contextData))
      .min(1, "At least one payment is required"),
  });
};

// Add Receipt Schema
const receiptDataSchema = Yup.object().shape({
  total_amount: Yup.number().required("Amount is required"),
  // payment_method: Yup.string().required("Payment Method is required"),
  description: Yup.string().required("Description is required"),
});

export const receiptSchema = (contextData) => {
  return Yup.object().shape({
    vendor_id: Yup.string()
      .required(
        `${getModuleNamingBySlug(
          contextData?.organizationData,
          "vendors",
          "Vendor",
        )} is required.`,
      )
      .nullable(),
    asset_id: Yup.string()
      .required(
        `${getModuleNamingBySlug(
          contextData?.organizationData,
          "assets",
          "Asset",
        )} is required.`,
      )
      .nullable(),
    sub_asset_id: Yup.string()
      .required(
        `${getModuleNamingBySlug(
          contextData?.organizationData,
          "sub-assets",
          "Sub Asset",
        )} is required.`,
      )
      .nullable(),
    // file_note: Yup.string().required("File note is required"),
    receipt_data: Yup.array()
      .of(receiptDataSchema)
      .min(1, "At least one receipt data entry is required"),
  });
};

export const AddReceiptSchema = (contextData) => {
  return Yup.object().shape({
    payeer: Yup.string().required("Payer is required").nullable(),

    contact_id: Yup.string()
      .nullable()
      .when("payeer", {
        is: (payeer) => payeer !== "vendor",
        then: (schema) =>
          schema.required(
            `${getModuleNamingBySlug(
              contextData?.organizationData,
              "contacts",
              "Customer",
            )} is required.`,
          ),
        otherwise: (schema) => schema.notRequired(),
      }),

    vendor_id: Yup.string()
      .nullable()
      .when("payeer", {
        is: "vendor",
        then: (schema) =>
          schema.required(
            `${getModuleNamingBySlug(
              contextData?.organizationData,
              "vendors",
              "Vendor",
            )} is required.`,
          ),
        otherwise: (schema) => schema.notRequired(),
      }),

    payment_method: Yup.string().required("Payment Method is required"),
    receipts: Yup.array()
      .of(receiptSchema(contextData))
      .min(1, "At least one receipt is required"),
  });
};

export const AddContactSchema = Yup.object().shape({
  last_name: Yup.string().required("Last name is required"),
});

export const AddSupplierSchema = Yup.object().shape({
  last_name: Yup.string().required("Last name is required"),
});

export const AddBeneficarySchema = Yup.object().shape({
  last_name: Yup.string().required("Last name is required"),
});

export const AddContractSchema = (contextData) => {
  return Yup.object().shape({
    vendor_id: Yup.string().required(
      `${getModuleNamingBySlug(
        contextData?.organizationData,
        "vendors",
        "Vendor",
      )} is required.`,
    ),
    asset_id: Yup.string().required(
      `${getModuleNamingBySlug(
        contextData?.organizationData,
        "assets",
        "Asset",
      )} is required.`,
    ),
    sub_asset_id: Yup.string().required(
      `${getModuleNamingBySlug(
        contextData?.organizationData,
        "sub-assets",
        "Sub Asset",
      )} is required.`,
    ),
    contract_number: Yup.string().required("Contract number is required"),
    contract_value: Yup.string().required("Contract value is required"),
    contract_value_exc: Yup.string().required(
      "Contract value (exc.) is required",
    ),
  });
};

export const AddTrustSchema = Yup.object().shape({
  business_name: Yup.string()
    .required("Trust Name is required.")
    .max(200, "Maximum 200 Character")
    .matches(
      BUSINESSNAME_VALIDATOR,
      "Trust name can contain letters, numbers, ampersand(&), dot(.), comma(,), apostrophe('), hyphen(-), parentheses(), slashes(/) & spaces.",
    )
    .nullable(),
  first_name: firstName,
  last_name: requiredLastName,
  street: requiredAddress,
  state_id: Yup.string().required("State name is required.").nullable(),
  suburb_id: Yup.string().required("Suburb name is required.").nullable(),
  postal_code: Yup.string().required("Postal Code is required."),
  account_name: requiredBankAccountName,
  account_number: requiredAccountNumber,
  bsb: requiredBSB,
  bank_id: requiredBankName,
  premiums: Yup.array().of(
    Yup.object().shape({
      code: Yup.string().required("Code is required").trim(),
      premium_type: Yup.string().required("Premium type is required"),
      amount: Yup.string()
        .required("Amount is required")
        .min(0, "Amount cannot be negative"),
    }),
  ),
  commissions: Yup.array().of(
    Yup.object().shape({
      code: Yup.string().required("Code is required").trim(),
      commission_type: Yup.string().required("Commission type is required"),
      amount: Yup.string()
        .required("Amount is required")
        .min(0, "Amount cannot be negative"),
    }),
  ),
});

export const AddOrganizationSchema = Yup.object().shape({
  business_name: requiredBusinessName,
  business_email: email,
  type: Yup.string().required("Type is required.").nullable(),
  street: requiredAddress,
  state_id: Yup.string().required("State name is required.").nullable(),
  suburb_id: Yup.string().required("Suburb name is required.").nullable(),
  postal_code: Yup.string().required("Postal Code is required."),
});

export const AddUserSchema = Yup.object().shape({
  last_name: Yup.string().required("Last name is required"),
  email: email,
  role_id: Yup.mixed().required("Role is required"),
  organization_id: Yup.array()
    .of(Yup.string().trim().min(1, "Invalid ID"))
    .min(1, "At least one organization must be selected")
    .required("Organization is required"),
});

export const AddJobSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  code: Yup.string().required("Code is required"),
});

export const AddTaskSchema = Yup.object().shape({
  ts_job_id: Yup.string().required("Job is required.").nullable(),
  title: Yup.string().required("Title is required"),
  code: Yup.string().required("Code is required"),
});

export const AddOfficeSchema = Yup.object().shape({
  street: requiredAddress,
  state_id: Yup.string().required("State name is required.").nullable(),
  suburb_id: Yup.string().required("Suburb name is required.").nullable(),
  postal_code: Yup.string().required("Postal Code is required."),
});

export const AddSupportTicketSchema = Yup.object({
  trust_id: Yup.string().required("Trust is required.").nullable(),
  subject: Yup.string().required("Subject is required."),
});

export const AddAdminUserSchema = Yup.object().shape({
  last_name: Yup.string().required("Last name is required"),
  email: email,
  role_id: Yup.mixed().required("Role is required"),
});

export const AddAdminRoleSchema = Yup.object().shape({
  name: Yup.string().required("Role Name is required"),
  type: Yup.mixed().required("Type is required"),
});

export const AddAdminModuleSchema = Yup.object().shape({
  organization_type_id: Yup.string().required("Organization Type is required"),
  module_id: Yup.string().required("Module is required"),
  name: Yup.string().required("Name is required"),
});

export const AddChartOfAccountSchema = Yup.object().shape({
  account_type_id: Yup.string().required("Account Type is required"),
  type: Yup.string().required("Type is required"),
  tax: Yup.string().required("Tax is required"),
  name: Yup.string().required("Name is required"),
  code: Yup.string().required("Code is required"),
  description: Yup.string().required("Description is required"),
});

export const AddAdminVersionSchema = Yup.object().shape({
  version_number: Yup.string().required("Version Number is required"),
  name: Yup.string().required("Name is required"),
  description: Yup.string().required("Please enter description"),
});

const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

const SUPPORTED_FORMATS = [
  "application/pdf", // .pdf
];

export const AddAdminPolicySchema = Yup.object().shape({
  organization_type_id: Yup.string().required("Organization Type is required"),
  version_id: Yup.string().required("Version number is required"),
  policy_file: Yup.array()
    .min(1, "Policy file is required")
    // File size check (only when file exists)
    .test("fileSize", "File size is too large (max 5MB)", (files) => {
      if (!files) return true;

      return files.every((item) => {
        if (item.file) {
          return item.file.size <= MAX_FILE_SIZE;
        }
        return true; // skip check for existing file {name, url}
      });
    })

    // File type check (only when file exists)
    .test("fileType", "Unsupported file format", (files) => {
      if (!files) return true;

      return files.every((item) => {
        if (item.file) {
          return SUPPORTED_FORMATS.includes(item.file.type);
        }
        return true; // skip for stored files
      });
    }),
});

export const AddAdminSectionSchema = Yup.object().shape({
  organization_type_id: Yup.string().required("Organization Type is required"),
  version_id: Yup.string().required("Version number is required"),
  section_type: Yup.string().required("Section Type is required"),
  order: Yup.string().required("Order is required"),
  title: Yup.string().required("Title is required"),
});

export const AddAdminQuestionSchema = Yup.object().shape({
  organization_type_id: Yup.string().required("Organization Type is required"),
  version_id: Yup.string().required("Version number is required"),
  section_id: Yup.string().required("Section is required"),
  section_type: Yup.string().required("Section Type is required"),
  order: Yup.string().required("Order is required"),
  label: Yup.string().required("Label is required"),
  question: Yup.string().required("Question is required"),
});
export const AddAdminConditionSchema = Yup.object().shape({
  organization_type_id: Yup.string().required("Organization Type is required"),
  version_id: Yup.string().required("Version number is required"),
  section_type: Yup.string().required("Section Type is required"),
  order: Yup.string().required("Order is required"),
  risk_level: Yup.string().required("Risk Level is required"),
  risk_action: Yup.string().required("Risk Action is required"),
  color: Yup.string().required("Color is required"),
  conditions: Yup.array()
    .of(
      Yup.object({
        sections: Yup.array()
          .of(Yup.string().required("Section is required"))
          .min(1, "At least one section is required"),

        operator: Yup.string().required("Operator is required"),

        total: Yup.string().when("operator", {
          is: (op) => op !== "Between",
          then: (schema) => schema.required("Total is required"),
          otherwise: (schema) => schema.notRequired(),
        }),

        min: Yup.string().when("operator", {
          is: "Between",
          then: (schema) => schema.required("Min is required"),
          otherwise: (schema) => schema.notRequired(),
        }),

        max: Yup.string().when("operator", {
          is: "Between",
          then: (schema) =>
            schema.required("Max is required").when("min", (min, schema) => {
              const minValue = Array.isArray(min)
                ? Number(min[0])
                : Number(min);

              return minValue !== undefined && !isNaN(minValue)
                ? schema.test(
                    "max-greater-than-min",
                    "Max cannot be less than Min",
                    (max) =>
                      max !== undefined && !isNaN(max)
                        ? Number(max) >= minValue
                        : true,
                  )
                : schema;
            }),
          otherwise: (schema) => schema.notRequired(),
        }),
      }),
    )
    .min(1, "At least one condition is required"),
});

export const AddWithdrawalAccountSchema = Yup.object().shape({
  account_name: requiredBankAccountName,
  account_number: requiredAccountNumber,
  bsb: requiredBSB,
  bank_id: requiredBankName,
});

export const AddInvoiceSchema = (contextData) => {
  return Yup.object({
    contact_id: Yup.string()
      .required(
        `${getModuleNamingBySlug(
          contextData?.organizationData,
          "contacts",
          "Customer",
        )} is required.`,
      )
      .nullable(),
    // invoice_number: Yup.string().required("Invoice number is required"),
    // note: Yup.string().required("Note is required"),
    items: Yup.array().of(
      Yup.object({
        vendor_id: Yup.string()
          .required(
            `${getModuleNamingBySlug(
              contextData?.organizationData,
              "vendors",
              "Vendor",
            )} is required.`,
          )
          .nullable(),
        asset_id: Yup.string()
          .required(
            `${getModuleNamingBySlug(
              contextData?.organizationData,
              "assets",
              "Asset",
            )} is required.`,
          )
          .nullable(),
        sub_asset_id: Yup.string()
          .required(
            `${getModuleNamingBySlug(
              contextData?.organizationData,
              "sub-assets",
              "Sub Asset",
            )} is required.`,
          )
          .nullable(),
        contract_id: Yup.string().nullable(),
        ts_job_id: Yup.string().nullable(),
        ts_task_id: Yup.string().nullable(),
        total_amount: Yup.number().required("Amount required"),
        amount: Yup.number().required("Amount required"),
        gst_amount: Yup.number().required("GST amount required"),
        net_amount: Yup.number().required("Net amount required"),
        tax: Yup.number().required("Tax required"),
        description: Yup.string().required("Description required"),
      }),
    ),
  });
};

export const AddAdminStateSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  short_name: Yup.string().required("Short Name is required"),
});

export const AddAdminSuburbSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  state_id: Yup.string().required("State is required.").nullable(),
});

export const AddOpeningBalanceSchema = (contextData) => {
  return Yup.object().shape({
    contactable_type: Yup.number()
      .required("Contact type is required.")
      .nullable(),

    contactable_id: Yup.string().when("contactable_type", {
      is: 1,
      then: (schema) =>
        schema
          .required(
            `${getModuleNamingBySlug(
              contextData?.organizationData,
              "vendors",
              "Vendor",
            )} is required.`,
          )
          .nullable(),
      otherwise: (schema) =>
        schema.when("contactable_type", {
          is: 2,
          then: (s) =>
            s
              .required(
                `${getModuleNamingBySlug(
                  contextData?.organizationData,
                  "contacts",
                  "Customer",
                )} is required.`,
              )
              .nullable(),
          otherwise: (s) => s.required("Contact type is required.").nullable(),
        }),
    }),

    opening_balance: Yup.string()
      .required("Opening balance is required.")
      .nullable(),
  });
};

export const AdminTrainingSchema = Yup.object().shape({
  organization_type_ids: Yup.array()
    .of(Yup.string().required("Organization Type is required"))
    .min(1, "At least one Organization Type is required"),
  banner_image: Yup.mixed().required("Please upload training image"),
  order: Yup.number()
    .typeError("Order should be a number")
    .required("Please enter Order"),
  title: Yup.string().required("Please enter title"),
  description: Yup.string().required("Please enter description"),
  link: Yup.string().url().required("Please enter link"),
  questions: Yup.array().of(
    Yup.object().shape({
      question: Yup.string().required("Enter question"),
      type: Yup.string().required("Select type"),
      answer: Yup.string().required("Select correct answer"),

      // options: Yup.array().when("type", {
      //   is: "1",
      //   then: Yup.array()
      //     .of(
      //       Yup.object().shape({
      //         label: Yup.string().required("Label required"),
      //         text: Yup.string().required("Option text required"),
      //         order: Yup.number()
      //           .typeError("Order must be number")
      //           .required("Order required")
      //       })
      //     )
      //     .min(1, "At least one option required")
      // })
    }),
  ),
});

export const AdminAssessmentSchema = Yup.object().shape({
  banner_image: Yup.mixed().nullable(),
  organization_type_ids: Yup.array()
    .of(Yup.string().required("Organization Type is required"))
    .min(1, "At least one Organization Type is required"),
  title: Yup.string().required("Please enter title"),
  description: Yup.string().required("Please enter description"),
  questions: Yup.array().of(
    Yup.object().shape({
      question: Yup.string().required("Enter question"),
      type: Yup.string().required("Select type"),
      answer: Yup.string().required("Select correct answer"),
    }),
  ),
});

export const AddIncidentSchema = (contextData) => {
  return Yup.object().shape({
    incident_type: Yup.string().required("Incident Type is required"),
    contactable_type: Yup.number()
      .required("Contact type is required.")
      .nullable(),

    contactable_id: Yup.string().when("contactable_type", {
      is: 1,
      then: (schema) =>
        schema
          .required(
            `${getModuleNamingBySlug(
              contextData?.organizationData,
              "vendors",
              "Vendor",
            )} is required.`,
          )
          .nullable(),
      otherwise: (schema) =>
        schema.when("contactable_type", {
          is: 2,
          then: (s) =>
            s
              .required(
                `${getModuleNamingBySlug(
                  contextData?.organizationData,
                  "contacts",
                  "Customer",
                )} is required.`,
              )
              .nullable(),
          otherwise: (s) => s.required("Contact type is required.").nullable(),
        }),
    }),
    verification_date: Yup.string().required("Verification Date is required"),
    verified_by_id: Yup.string().required("Verified By is required"),
  });
};

export const receiptRefundSchema = () => {
  return Yup.object().shape({
    refund_date: Yup.date().required("Refund date is required"),

    refund_amount: Yup.number()
      .transform((value, originalValue) => {
        if (typeof originalValue === "string") {
          return Number(originalValue.replace(/,/g, ""));
        }
        return value;
      })
      .typeError("Amount must be a valid number")
      .required("Amount is required")
      .min(0.01, "Amount must be greater than 0")
      // .max(maxAmount, `Amount cannot be greater than $${formatNumber(maxAmount)}`),
      .when("remaining_balance", (remaining_balance, schema) =>
        schema.max(
          remaining_balance,
          // "Refund amount cannot exceed remaining balance",
          `Amount cannot be greater than $${formatNumber(remaining_balance)}`
        ),
      ),
  });
};
